import React from "react";
import { Button, Popover } from "antd";
import OrderDTO from "@/dto/order/OrderDTO";
import { observer } from "mobx-react-lite";

interface WithPopoverTipProps {
    onSearch?: () => void;

    otherTip?: React.ReactNode;

    children: React.ReactNode;
}

export function getRealBuyerNickName(order: OrderDTO) {
    const buyerNickname = order.buyerNickname;

    if (buyerNickname !== undefined && buyerNickname !== null) {
        return buyerNickname;
    }

    return order.buyerUsername;
}

const WithPopoverTip: React.FC<WithPopoverTipProps> = observer(function (props) {
    const { onSearch, otherTip, children } = props;

    return (
        <Popover
            content={
                <div>
                    <Button type="link" onClick={onSearch} className="fs12">
                        查找该买家所有订单
                    </Button>

                    {otherTip}
                </div>
            }
        >
            <span>{children}</span>
        </Popover>
    );
});

export default WithPopoverTip;
